import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { themeV2 as theme } from '../../../../themeV2';

const ButtonTextXL = css`
  font-weight: ${theme.fonts.fontWeightSemibold};
  font-family: ${theme.fonts.main};
  letter-spacing: -0.01em;
  font-feature-settings: 'ss04' on, 'cv10' on, 'cv03' on, 'cv04' on;
  letter-spacing: -0.02em;
  font-size: 24px;
  line-height: 32px;
`;

const headingSharedStyles = css`
  font-weight: ${theme.fonts.fontWeightExtrabold};
  letter-spacing: -0.01em;
  font-family: ${theme.fonts.main};
  font-feature-settings: 'ss04' on, 'cv10' on, 'cv03' on, 'cv04' on;
`;

const Heading1 = css`
  ${headingSharedStyles};
  font-size: 40px;
  line-height: 48px;
  letter-spacing: -0.02em;
`;
export const SummaryContainer: ReturnType<typeof styled.div> = styled.div`
  margin-bottom: 30px;
  color: ${theme.colors.lightest};
`;

export const SummaryHeader: ReturnType<typeof styled.div> = styled.h1`
  margin-bottom: 38px;
  text-align: center;
  ${Heading1};
`;

export const SummaryText: ReturnType<typeof styled.div> = styled.p`
  ${ButtonTextXL};
`;

// https://github.com/microsoft/TypeScript/issues/47663#issuecomment-1519138189
export const ButtonContainer: ReturnType<typeof styled.div> = styled.div`
  margin-top: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
